import * as React from 'react';
import { BaSeButton, ButtonProps } from '../components/button/button/button';
import { BaSeLogoSebrae } from '../components/image/logo-sebrae/logo-sebrae';
import { BaSeHeading1 } from '../components/typography/heading/heading1';
import { BaSeHeading4 } from '../components/typography/heading/heading4';
import { BaSeParagraph } from '../components/typography/paragraph/paragraph';
import { BaSeI18nConsumer } from '../contexts/i18n';
import { BaSeTheme } from '../theme';
import { CenterStyled } from './styled/center';
import { PageWrapperStyled } from './styled/page-wrapper';
import {
  RotateTransitionStyled,
  SlideDownTransitionStyled,
} from './styled/rotate-transition';
import { SideBySideStyled } from './styled/side-by-side';

const transitionDelay = '2s';

export interface ErrorPageProps {
  title?: string;
  error?: string;
  button?: Partial<ButtonProps>;
  showButton?: boolean;
}

export const BaSeErrorPage: React.FC<ErrorPageProps> = ({
  title,
  error,
  button,
  showButton = true,
}) => {
  const hasButton = React.useMemo(
    () => showButton && (window.history.length > 1 || button),
    [button, showButton],
  );

  return (
    <BaSeI18nConsumer>
      {({ getMessage }) => (
        <PageWrapperStyled
          color={BaSeTheme.colors.institucionais.cinzaSebrae97}
        >
          <CenterStyled>
            <SideBySideStyled>
              <div
                style={{
                  margin: '10px 0',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '24px',
                }}
              >
                <BaSeLogoSebrae width={143} easterEgg={true} />
                {hasButton && (
                  <SlideDownTransitionStyled
                    initialOpacity={0}
                    delay={transitionDelay}
                  >
                    <BaSeButton
                      onClick={() => window.history.back()}
                      type="tertiary"
                      leftIcon={button ? button.leftIcon : 'history-alt'}
                      color={BaSeTheme.colors.institucionais.cinzaSebrae20}
                      value={getMessage('errorPage.backButton')}
                      {...button}
                    />
                  </SlideDownTransitionStyled>
                )}
              </div>
              <div>
                <BaSeHeading1
                  isBold={true}
                  color={BaSeTheme.colors.institucionais.azulSebrae}
                >
                  <RotateTransitionStyled rotation={90} delay={transitionDelay}>
                    : (
                  </RotateTransitionStyled>
                  <br />
                  Ops!
                </BaSeHeading1>
                <div style={{ margin: '21px 0' }}>
                  <BaSeHeading4
                    isBold={true}
                    color={BaSeTheme.colors.institucionais.cinzaSebrae20}
                  >
                    {title || getMessage('errorPage.defaultTitle')}
                  </BaSeHeading4>
                  <BaSeParagraph
                    color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                  >
                    {error || getMessage('errorPage.defaultDescription')}
                  </BaSeParagraph>
                </div>
              </div>
            </SideBySideStyled>
          </CenterStyled>
        </PageWrapperStyled>
      )}
    </BaSeI18nConsumer>
  );
};
